import React from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { motion } from "framer-motion";
import heroImg from '../assets/heroImg.avif'
import StatsSection from './StatsSection';
import TypeWord from './TypeWord';

export default function HeroBanner() {

  const navigate = useNavigate();

  const redirect = () => {
    navigate('/apply-now');
  };

  return (
    <section className="relative bg-[#072c4c] overflow-hidden">

      {/* Background Glow */}
      <div className="absolute top-0 left-0 w-72 h-72 bg-cyan-500/20 blur-3xl rounded-full"></div>
      <div className="absolute bottom-0 right-0 w-72 h-72 bg-orange-500/20 blur-3xl rounded-full"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-2 items-center relative z-10">

        {/* Left Content */}
        <div className="text-center lg:text-left text-white">
          <h1 className="text-2xl sm:text-4xl lg:text-4xl leading-tight font-bold">
            <TypeWord />
          </h1>

          <p className='py-6 mt-4 text-gray-300 text-sm sm:text-base leading-8'>
            Manage temporary cash flow gaps and important financial commitments through a secure and structured digital process.
          </p>

          <button
            className="mt-4 px-6 py-3 rounded-full bg-white/10 backdrop-blur-md border border-white/20 text-white hover:bg-[#FF7B0E] transition shadow-lg"
            onClick={redirect}
          >
            Apply Instantly
          </button>

        </div>

        {/* Right Glass Card */}
        <div className="flex justify-center lg:justify-end">
          <div className="relative p-4 sm:p-6 rounded-2xl">

            <div className="relative">
              <img
                src={heroImg}
                alt="Hero"
                className="rounded-full animate-smoothScale"
                style={{ width: '470px' }}
              />
            </div>

          </div>
        </div>

      </div>

      <StatsSection />

    </section>
  )
}